import ReminderEmailsSection from './ReminderEmailsSection';
import { ReminderEmailsSectionProps, ReminderEmailsSectionValueProps } from './types';

export type { ReminderEmailsSectionProps, ReminderEmailsSectionValueProps };
export default ReminderEmailsSection;
